import React, {useEffect, useState} from "react";
import { Modal } from "@ts-digital/vrc";
import {  useSelector } from "react-redux";
import { useIntl } from "react-intl";

const DownloadProgress = () => {
  const download = useSelector(state => state.download);
  const intl = useIntl();
  const [downloadLoaderModal, setDownloadLoaderModal] = useState(false);
  const [couterFakeProgress, setCouterFakeProgress] = useState(0);

  useEffect(() => {
    if (!download.status.started) {
      setDownloadLoaderModal(false);
      return;
    }

    setDownloadLoaderModal(true);

    if (download?.progress > 0){
      /** Non avendo la size completa del file vado ad incrementare counter fino al 99% */
      setCouterFakeProgress((prev) => (prev.couterFakeProgress + 5 > 99) ? 99 : prev.couterFakeProgress + 5 );
    }
  }, [download.status?.started, download?.progress]);

  const renderDownloadLoading = () => {
    return (
      <Modal
        visible={downloadLoaderModal}
        title={intl.formatMessage({id: "documents.downloading", defaultMessage: "Download in corso"}) }
        onClose={() => {
          setDownloadLoaderModal(false);
        }}
        type="primary"
      >
        <div style={{ zIndex: "9999999", width: "400px", margin: "20px 0" }}>
          <div className="descriptiveDiv">
            <div>
              {download ? download.loadingSize : 0}
              <div className="percentageText">{couterFakeProgress}%</div>
            </div>
          </div>

          <div className={"progressBar startProgress"}>
            <div
              className={"progressColored"}
              style={{
                width: couterFakeProgress ? couterFakeProgress + "%" : 0,
                backgroundImage: "linear-gradient(274deg, #00c3ea, #0090d1)",
                height: "100%"
              }}
            />
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div className="downloadProgressModal" style={{ zIndex: "999999" }}>
      {renderDownloadLoading()}
    </div>
  );
};

export default DownloadProgress;
